<template>
  <div id="app">
    <head-Back title="分享"></head-Back>
    <div class="page">
      <div class="page-button">
        <button
          v-clipboard:copy="invitationCode"
          v-clipboard:success="copy"
          v-clipboard:error="onError"
        >点击复制链接邀请</button>
      </div>
    </div>
  </div>
</template>


<script>
import headBack from "../common/head-back";
import api from "../../api/index";
import wxapi from "../../utils/wxapi";
import {
  commonShare,
  shareTitle,
  shareUrl,
  shareImg,
  shareDesc
} from "../../utils/wxshare";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "管理中心"
  },
  name: "app",
  data() {
    return {
      msg: "注册协议",
      shareConfigdata: null,
      link: "",
      invitationCode: "invitationCode"
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
    this.getCopyUrl();
    //获取微信data数据，分享数据
    let url = window.location.href;
    this.link = url;
    var data = {
      url: this.link
    };

    let opstion = {
      title: "一个懂事的聊天APP", // 分享标题
      link: window.location.href,
      imgUrl: "http://wap.haoyunba.com/static/img/logo-hyb.png", // 分享图标
      desc: "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！"
    };
    console.log("分享的信息：" + JSON.stringify(opstion));
    commonShare(
      this,
      opstion.title,
      opstion.link,
      opstion.imgUrl,
      opstion.desc
    );
  },
  methods: {
    getCopyUrl() {
      var userInfo = this.getUserInfo;
      //分享地址 invitationCode
      var shareUrl =
        "http://" +
        window.location.host +
        "/#/share?type=1&shareid" +
        userInfo.id;

      var data = {
        url: shareUrl
      };

      this.$axiosHttp({
        method: "POST",
        url: api.qml.getdwz,
        data: data
      })
        .then(res => {
          console.log("发送验证码结果" + JSON.stringify(res));
          if (res.code == 0) {
            console.log(res.result);
            this.invitationCode =
              "你的好友邀请你使用好运吧APP，点击立即 " +
              res.result +
              " 开始使用吧";
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    },
    copy(e) {
      console.log(e.text);
      tips.toast("复制成功，快去黏贴分享吧");
    },
    onError(e) {
      console.log(e);
      tips.toast("复制失败");
    },
    toshareWx() {
      var data = this.shareConfigdata;
    },
    toShareDx() {
      var phone = "";
      //发送短信的内容
      var name = "分享至";
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      var isiOS =
        !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf("iPhone") > -1; //ios终端
      if (isAndroid) {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      } else if (isiOS) {
        var sendcontent = "sms:" + phone + "&body=" + name; //ios  ///
        window.location.href = sendcontent;
      } else {
        var sendcontent = "sms:" + phone + "?body=" + name; //android  ///
        window.location.href = sendcontent;
      }
    }
  },
  components: {
    headBack
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 2050px;
  background: url("../../assets/img/toshare-back@2x.png");
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}

.page-button button {
  width: 585px;
  height: 100px;
  background: rgba(255, 212, 79, 1);
  border-radius: 50px;
  font-size: 43px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(125, 60, 2, 1);
  line-height: 100px;
  border: none;
  margin-top: 1322px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/toshare.vue